import { select } from "@utils/function";

export default function SignatureLogo() {
  // check if signature partner is available
  if (!HQ.Properties.signaturePartner) return;

  // check if image is available
  if (
    !HQ.Properties.signaturePartnerLogo &&
    !HQ.Properties.signaturePartnerFullLogo
  ) {
    return;
  }

  const signatureWrapper = select(".signature-wrapper");

  const signatureURL = createSignatureUrl();

  if (signatureURL) {
    signatureWrapper.appendChild(signatureURL);
  }

  // const sidebar = select(".slider-wrapper");
  // sidebar.insertAdjacentElement("afterend", signatureWrapper);

  const config = {
    logo: {
      className: "signature-logo-icon",
      src: HQ.Properties.signaturePartnerLogo,
    },
    fullLogo: {
      className: "signature-logo-full",
      src: HQ.Properties.signaturePartnerFullLogo,
    },
  };

  addImageToSignatureWrapper(config, signatureWrapper);
}

/**
 * Add image to signature wrapper
 *
 * @param {object} config
 */
function addImageToSignatureWrapper(config, signatureWrapper) {
  const signatureLink = select(".signature-link");

  const { logo, fullLogo } = config;
  const { className: logoClassName, src: logoSrc } = logo;
  const { className: locoClassNameFull, src: logoSrcFull } = fullLogo;

  const place = signatureLink ? signatureLink : signatureWrapper;

  if (logoSrc) {
    place.appendChild(addImageToSignatureLink(logoSrc, logoClassName));
  }
  if (logoSrcFull) {
    place.appendChild(addImageToSignatureLink(logoSrcFull, locoClassNameFull));
  }
}

/**
 * Add image to signature link
 *
 * @param {string} logo
 * @param {string} className\
 *
 * @returns HTMLAnchorElement
 */
function addImageToSignatureLink(logo, className) {
  const logoImage = document.createElement("img");
  logoImage.src = logo;
  logoImage.classList.add(className);
  logoImage.classList.add("img-fluid");
  logoImage.alt = "signature partner logo";

  return logoImage;
}

/**
 * Create link url
 *
 * @returns HTMLAnchorElement
 */
function createSignatureUrl() {
  if (!HQ.Properties.signaturePartnerLogoUrl) return;

  const createHref = document.createElement("a");
  createHref.href = HQ.Properties.signaturePartnerLogoUrl;
  createHref.target = "_blank";
  createHref.rel = "noopener noreferrer";
  createHref.classList.add("signature-link");
  createHref.classList.add("d-block");

  return createHref;
}
